var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-1v1.052c4.777.5 8.5 4.539 8.5 9.448a9.5 9.5 0 0 1-19 0c0-4.909 3.723-8.948 8.5-9.448V3h-1a1 1 0 0 1-1-1M5.878 3.385a1 1 0 0 1 0 1.414l-.75.75-.75.75a1 1 0 0 1-1.414-1.414l.75-.75.75-.75a1 1 0 0 1 1.414 0m12.244 0a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414M12 6a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m0 2.5a1 1 0 0 1 1 1v3.434l2.015 1.209a1 1 0 0 1-1.03 1.714l-2.5-1.5A1 1 0 0 1 11 13.5v-4a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgStopwatch;